/**
 * Created by DSadler on 25/04/2017.
 */
import React, {Component} from 'react';
import {Drawer, IconButton, Tab, Tabs, Toolbar, ToolbarGroup} from "material-ui";
import BuildingBlocksContainer from "./BuildingBlocksContainer";
import ComponentSettingsContainer from "./ComponentSettingsContainer";
import HierarchyContainer from "./HierarchyContainer";

let tabStyles = {
  padding: "20px",
  height: "calc(100vh - 120px - 40px - 48px)",
  overflowY: "scroll"
};


class ToolBox extends Component {
  
  render() {
    return (
      <div
        onClick={this.props.click}>
        <Drawer
          width={600}
          openSecondary={true}
          open={this.props.visible}
          containerStyle={{top: "0px"}}
        >
          <Toolbar>
            <ToolbarGroup firstChild={true}>
              <IconButton tooltip="Close" iconClassName="material-icons" onTouchTap={this.props.hide}>close</IconButton>
              <IconButton
                tooltip={this.props.pinned ? "Unpin" : "Pin"}
                iconClassName="material-icons"
                onTouchTap={this.props.pinned ? this.props.unpin : this.props.pin}
              >place
              </IconButton>
            </ToolbarGroup>
          </Toolbar>
          <Tabs
            contentContainerStyle={tabStyles}
            value={this.props.tab}
            onChange={this.props.changeTab}
          >
            <Tab label="Building Blocks" value={0}>
              These components can be used to build a template. Drag them into the editor to use them!
              <BuildingBlocksContainer/>
            </Tab>
            <Tab label="Component Settings" value={1}>
              Edit detailed settings for a component below. These settings can easily break stuff so be careful.
              <ComponentSettingsContainer/>
            </Tab>
            <Tab label="Hierarchy" value={2}>
              <HierarchyContainer/>
            </Tab>
          </Tabs>
        </Drawer>
      </div>
    );
  }
}

export default ToolBox;


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/ToolBox/ToolBox.js